import React from "react";
import styled from 'styled-components'
import { useTable } from 'react-table'
import styles from '../settings.module.scss';
import cn from 'classnames';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 0px;
    width:100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 20px 10px;
     min-width:100px;
     text-align:center;
      :last-child {
        border-right: 0;
      }
      td{
        font: normal normal normal 18px/22px Montserrat;
      }
    }
    tbody tr:nth-child(odd) {background: #ebeaea}
  }
`
function Table({ columns, data }) {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
    })

    // Render the UI for your table
    return (
        <table {...getTableProps()}>
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

function Mysettinglist() {

    const columns = React.useMemo(
        () => [
            {
                Header: 'Driver Name',
                disableSortBy: false,
                accessor: 'name',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value}
                            </h5>

                        </div></>
                    );
                }
            },
            {
                Header: 'Email Id',
                disableSortBy: false,
                accessor: 'email',
                Cell: (props) => {
                    return (
                            <span>
                                {props.value}
                            </span>
                    );
                }
            },
            {
                Header: 'Vehicle Assigned',
                disableSortBy: false,
                accessor: 'vehicleAssigned',
                Cell: (props) => {
                    return (

                      
                            <span className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value !== '' ? props.value : <input type='text' className={cn(styles.tableinput)} placeholder={"Enter the EVSE ID"} />}
                            </span>
                    );
                }
            },
            {
                Header: 'Site',
                disableSortBy: false,
                accessor: 'site',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value}
                            </h5>

                        </div></>
                    );
                }
            },
            {
                Header: 'Phone No',
                disableSortBy: false,
                accessor: 'phoneNo',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value}
                            </h5>

                        </div></>
                    );
                }
            },
            {
                Header: 'App Link',
                disableSortBy: false,
                accessor: 'appLink',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value}
                            </h5>

                        </div></>
                    );
                }
            },
            {
                Header: 'Action',
                disableSortBy: false,
                accessor: 'action',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>

                            </h5>

                        </div></>
                    );
                }
            },
            {
                Header: 'Status',
                disableSortBy: false,
                accessor: 'status',
                Cell: (props) => {
                    return (

                        <><div className={cn(styles.col_charger, styles.col_charger_layout)}>
                            <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                                {props.value}
                            </h5>

                        </div></>
                    );
                }
            },
        ],
        []
    )

    const data = [

        {
            'name': 'Jhon Paul',
            'email': 'johnpaul@nuvve.com',
            'vehicleAssigned': '12345432',
            'site': 'Site1',
            'phoneNo': '8759837987',
            'appLink': 'Yes',
            'Action': '',
            'status': ''
        },
        {
            'name': 'Jhon Paul',
            'email': 'johnpaul1@nuvve.com',
            'vehicleAssigned': '12345432',
            'site': 'Site1',
            'phoneNo': '8759837987',
            'appLink': 'Yes',
            'Action': '',
            'status': ''
        },
        {
            'name': 'Jhon Paul',
            'email': 'johnpaul2@nuvve.com',
            'vehicleAssigned': '',
            'site': 'Site1',
            'phoneNo': '8759837987',
            'appLink': 'Yes',
            'Action': '',
            'status': ''
        },
        {
            'name': 'Jhon Paul',
            'email': 'johnpaul3@nuvve.com',
            'vehicleAssigned': '12345432',
            'site': 'Site1',
            'phoneNo': '8759837987',
            'appLink': 'Yes',
            'Action': '',
            'status': ''
        },
        {
            'name': 'Jhon Paul',
            'email': 'johnpaul4@nuvve.com',
            'vehicleAssigned': '',
            'site': 'Site1',
            'phoneNo': '8759837987',
            'appLink': 'Yes',
            'Action': '',
            'status': ''
        }
    ]

    return (
        <Styles>
            <Table columns={columns} data={data} />
        </Styles>
    )
}
export default Mysettinglist
